module.exports = __webpack_public_path__ + "img/visa.47b8cbc1.svg";